import {Decimal,} from 'decimal.js';

/**
 * [一般開発者利用可]
 * ログイン用のユーザーモデル
 */
export class LoginUserVO {

  /** 契約情報ID（ハッシュ値） . */
  hashId!: string;

  /** 契約情報ID */
  keiyakuInfoId!: Decimal;

  /** 取引メニュー番号 . */
  menuNo!: string;

  /** アクセストークン */
  accessToken!: string | null;

  /** リフレッシュトークン */
  refreshToken!: string | null;

  /** リフレッシュトークン有効期限 */
  refreshTokenExpired?: Date;

  /** 承認番号 . */
  shouninNo!: string;

  /** 言語区分 . */
  languageType!: string;

}
